import { inject } from '@angular/core';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
export class AgentLinkNavigatorService {
    constructor() {
        this.router = inject(Router);
    }
    async navigateToParams(params, fallbackHref) {
        try {
            const navigated = await this.router.navigate([], {
                queryParams: params,
                queryParamsHandling: '',
                replaceUrl: false,
            });
            if (!navigated) {
                window.location.href = fallbackHref;
            }
        }
        catch {
            window.location.href = fallbackHref;
        }
    }
}
AgentLinkNavigatorService.ɵfac = function AgentLinkNavigatorService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLinkNavigatorService)(); };
AgentLinkNavigatorService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AgentLinkNavigatorService, factory: AgentLinkNavigatorService.ɵfac, providedIn: 'root' });
